module.exports = __webpack_public_path__ + "img/Insurance.a49ae66c.svg";